import styled from "styled-components"

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: #fff;
  padding: 20px 20px 10px 20px;
  > * {
    margin-bottom: 10px;
  }
  border-radius: 12px;
  border: 3px solid #701ea8;
  max-width: 400px;
  button {
    background-color: transparent;
    border: none;
    outline: none;
  }

  > .order-summary {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 -20px -10px -20px;
    border-radius: 0 0 12px 12px;
    padding: 15px 20px 0 20px;

    background-color: #f8f8f8;

    .submit-button {
      align-self: center;
      margin-bottom: 12px;
    }
  }
`

export const Title = styled.div`
  font-family: "Rammetto One", cursive;
  color: #45106d;
  font-size: 1.35em;
  text-align: center;
`

export const ErrorMessage = styled.div`
  color: #f00;
  font-size: 0.7rem;
`

export const Condition = styled.div`
  display: flex;
  align-items: flex-start;
  > :first-child {
    margin-right: 12px;
  }
  p {
    margin: 0;
    font-size: 0.8rem;
  }
  a {
    color: #701ea8;
    text-decoration: underline;
  }
`

export const ChildrenSection = styled.div`
  margin-top: 20px;
  text-align: center;
`

export const SectionTitle = styled.div`
  font-size: 1.4em;
  color: #45106b;
  // font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
`

export const Info = styled.div`
  p {
    margin: 0;
  }
  margin-top: 8px;
  font-size: 0.7rem;
`

export const Children = styled.div`
  margin-top: 10px;
  margin-bottom: 15px;
  > * {
    margin-bottom: 10px;
  }
  > :last-child {
    margin-bottom: 0;
  }
`

export const AddChild = styled.div`
  display: flex;
  align-items: center;
  > :first-child {
    margin-right: 10px;
  }
  margin-top: 15px;
  font-size: 0.9rem;
  cursor: pointer;
  color: #0093d9;
`

export const Child = styled.div`
  display: flex;
  align-items: center;
  > :first-child {
    flex: 1;
    margin-right: 10px;
  }
`

export const RemoveChild = styled.div`
  cursor: pointer;
`

export const PlanSection = styled.div`
  //
`

export const Plan = styled.div`
  text-align: center;
  > .plan--price {
    font-size: 0.8rem;
    margin-bottom: 8px;
  }
  > .plan--up-to {
    font-size: 0.7rem;
  }
  > .plan--extras {
    font-size: 0.7rem;
    margin-top: 8px;
  }
  margin-bottom: 15px;
`

export const FormError = styled.div`
  background-color: #ec5e2e;
  padding: 8px;
  border-radius: 4px;
  color: white;
  text-align: center;
  a {
    text-decoration: underline;
    font-weight: bold;
  }
`
